module.exports = __webpack_public_path__ + "static/img/banner_pc.e59bc75.png";


//////////////////
// WEBPACK FOOTER
// ./src/module/active_26423/images/banner_pc.png
// module id = 92Ho
// module chunks = 41